/**
 * PORTED — RO-3-00c / #44470.
 * Origin: `excellent/app/_modes/section-title-toolbars.ts`.
 *
 * Pure registry — no server sink. Producers are the client rewrites of the
 * three toolbar builders (issues / sales / market), which fetch their own data
 * via `modes.issuesChrome` / `modes.salesChrome` / `modes.marketChrome`.
 */

import type { ReactNode } from "react";
import { IssuesTitleToolbar } from "./issues-title-toolbar";
import { SalesTitleToolbar } from "./sales-title-toolbar";
import { MarketTitleToolbar } from "./market-title-toolbar";

export interface TitleToolbarContext {
  searchParams: Record<string, string | string[] | undefined> | undefined;
  workspaceId: number;
  projectSlug?: string;
}

export type TitleToolbarProducer = (ctx: TitleToolbarContext) => ReactNode;

const REGISTRY: Record<string, TitleToolbarProducer> = {
  "work:work.queue": (ctx) => IssuesTitleToolbar(ctx),
  "work:work.planner": (ctx) => IssuesTitleToolbar(ctx),
  "customers:crm.pipeline": (ctx) => SalesTitleToolbar(ctx),
  "customers:market.hub": (ctx) => MarketTitleToolbar(ctx),
};

export function buildSectionTitleToolbar(
  mode: string,
  component: string | undefined,
  ctx: TitleToolbarContext,
): ReactNode {
  if (!component) return undefined;
  const producer = REGISTRY[`${mode}:${component}`];
  return producer ? producer(ctx) : undefined;
}
